import { Component } from 'react';
import { ErrorMsg } from 'components';

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, message: '', stack: '' };
	}

	/**
	 * @param {object} error
	 */
	static getDerivedStateFromError(error) {
		console.error('[ErrorBoundary] Error caught:', error);
		return { hasError: true, message: error.message };
	}

	/**
	 * @param {object} error
	 * @param {object} errorInfo
	 */
	componentDidCatch(error, errorInfo) {
		this.setState((prev) => {
			return { ...prev, stack: errorInfo.componentStack };
		});
	}

	render() {
		if (this.state.hasError) {
			return <ErrorMsg state={this.state} />;
		} else {
			return this.props.children;
		}
	}
}

export default ErrorBoundary;
